import { api } from "./api";

/**
 * Billing
 */
export function getInvoices(params) {
  return api.get(`/billing/invoice`, { params });
}

export function getPlan(params) {
  return api.get(`/billing/plan`, { params });
}

export function getUsage(params) {
  return api.get(`/billing/usage`, { params });
}

export function getQBCustomers(params) {
  return api.get(`/quickbooks/customers`, { params });
}

export function getQBInvoices(params) {
  return api.get(`/quickbooks/invoices`, { params });
}

export function getQBInvoice(id, params) {
  return api.get(`/quickbooks/invoices/${id}`, { params });
}

export function updateQBInvoiceSmsOverage(id, body) {
  return api.post(`/quickbooks/invoices/${id}/update-sms-overage`, body);
}

export function updateQBInvoiceCustomerCountOverage(id, body) {
  return api.post(`/quickbooks/invoices/${id}/add-customer-count-usage`, body);
}

export function sendQBInvoiceToCustomer(id) {
  return api.post(`/quickbooks/invoices/${id}/send-customer-invoice`);
}

export function chargeStripeCustomerForInvoice(id) {
  return api.post(`/quickbooks/invoices/${id}/charge-stripe-customer`);
}

export function invalidateBillingCaches() {
  return api.post(`/quickbooks/invoices/invalidate-caches`);
}

export function createQuickBooksPaymentForInvoice(id) {
  return api.post(`/quickbooks/invoices/${id}/create-quickbooks-payment`);
}

export function getBillingApiStatus() {
  return api.get(`/quickbooks/invoices/api-status`);
}

export function getSnowflakeOveragesForMonth(params) {
  return api.get(`/quickbooks/invoices/snowflake-overages`, { params });
}

export function bulkCreateQuickBooksPaymentForInvoices(data) {
  return api.post(`/quickbooks/invoices/bulk-create-quickbooks-payments`, data);
}

export function bulkChargeStripeCustomerForInvoice(data) {
  return api.post(`/quickbooks/invoices/bulk-charge-stripe-customers`, data);
}

export function bulkSendQBInvoiceToCustomer(data) {
  return api.post(`/quickbooks/invoices/bulk-send-customer-invoices`, data);
}

export function bulkUpdateQBInvoiceSmsOverage(data) {
  return api.post(`/quickbooks/invoices/bulk-update-sms-overage`, data);
}

export function bulkUpdateQBInvoiceCustomerCountOverage(data) {
  return api.post(`/quickbooks/invoices/bulk-add-customer-count-usage`, data);
}

export function getQBMailerInvoices(params) {
  return api.get(`/quickbooks/mailer-invoices`, { params });
}

export function getQBMailerInvoice(params) {
  return api.get(`/quickbooks/mailer-invoices/mailer-detail`, { params });
}

export function createQBMailerInvoiceWithOverage(data) {
  return api.post(
    `/quickbooks/mailer-invoices/create-qb-mailer-invoice-with-overage`,
    data,
  );
}

export function refreshQuickbooksToken(data) {
  return api.post(`/quickbooks/invoices/refresh-quickbooks-token`, data);
}

export function updateContractThirdPartyId(data) {
  return api.post(`/quickbooks/invoices/update-contract-third-party-id`, data);
}

export function refreshCacheForQBInvoices(data) {
  return api.post(`/quickbooks/invoices/refresh-cache-for-invoices`, data);
}

export function getContracts(params) {
  return api.get(`/billing/contract`, { params });
}

export function getContract(id) {
  return api.get(`/billing/contract/${id}`);
}

export function updateContract(id, data) {
  return api.patch(`/billing/contract/${id}`, data);
}

export function createContract(data) {
  return api.post(`/billing/contract`, data);
}

export function listContacts(params) {
  return api.get(`/billing/contact`, { params });
}

export function createContact(data) {
  return api.post(`/billing/contact`, data);
}

export function updateContact(id, data) {
  return api.patch(`/billing/contact/${id}`, data);
}

export function deleteContact(id) {
  return api.delete(`/billing/contact/${id}`);
}

/**
 * Billing Items
 */
export function getBillingItems(params) {
  return api.get(`/billing/items`, { params });
}

export function createBillingItem(data) {
  return api.post(`/billing/items`, data);
}

export function updateBillingItem(id, data) {
  return api.patch(`/billing/items/${id}`, data);
}

export function deleteBillingItem(id) {
  return api.delete(`/billing/items/${id}`);
}

/**
 * Billing Closers
 */
export function getClosers(params) {
  return api.get(`/billing/closers`, { params });
}

export function getClosersFromHubSpot(params) {
  return api.get(`/integration/hubspot/owners`, { params });
}

export function createCloser(data) {
  return api.post(`/billing/closers`, data);
}

export function updateCloser(id, data) {
  return api.patch(`/billing/closers/${id}`, data);
}

export function deleteCloser(id) {
  return api.delete(`/billing/closers/${id}`);
}

/**
 * Price Metrics
 */
export function getPriceMetrics(params) {
  return api.get(`/billing/price-metrics`, { params });
}

export function createPriceMetrics(data) {
  return api.post(`/billing/price-metrics`, data);
}

export function updatePriceMetrics(id, data) {
  return api.patch(`/billing/price-metrics/${id}`, data);
}

export function deletePriceMetrics(id) {
  return api.delete(`/billing/price-metrics/${id}`);
}

// Legacy aliases for backward compatibility
export const getUnitEconomics = getPriceMetrics;
export const createUnitEconomics = createPriceMetrics;
export const updateUnitEconomics = updatePriceMetrics;
export const deleteUnitEconomics = deletePriceMetrics;

/**
 * Contract Types
 */
export function getContractTypes(params) {
  return api.get(`/billing/contract-types`, { params });
}

export function createContractType(data) {
  return api.post(`/billing/contract-types`, data);
}

export function updateContractType(id, data) {
  return api.patch(`/billing/contract-types/${id}`, data);
}

export function deleteContractType(id) {
  return api.delete(`/billing/contract-types/${id}`);
}

/**
 * Voice Agent Admin (employee-ops only).
 * Cohort routed via `?cohort=plg|contracted`; filters passed through as
 * top-level params (has_agents, stripe_status, exempt, etc.) — see
 * VoiceAgentAdminFilter on the backend.
 */
export function getVoiceAgentAccounts(params) {
  return api.get(`/integration/voice-agent/employee-admin/accounts`, { params });
}
